import { useState } from 'react'
import webicon from '../../../../assets/webicon.png'
import {
  DatasetSync,
  deleteStorebyID,
  updateStore,
  Validatescript,
  ValidatewebsiteUrl,
  validatesitemapurl
} from '../../../../services/data'
import CreateStore from '../../../../util/createstore'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import TooltipWalkthrough from '../../../../util/walkthrough'
import { useSubscription } from '../../../../context/subscriptionprovider'
import validateJSON from '../../../../util/jsonvalidation'
import VerifyDomainPopup from '../../../BotCustom/component/owner_verify_popup'
import Cookies from 'js-cookie'
import { useAuth } from '../../../../context/logincontext'

const GetWebsiteStore = ({ handleback }) => {
  const [siteUrl, setSiteUrl] = useState('')
  const [sitemapUrl, setSitemapUrl] = useState('')
  const navigate = useNavigate()
  const [isProcessing, setIsProcessing] = useState(false)
  const { isRestricted, activePlan, limitedPermission } = useSubscription()

  const [showVerifyPopup, setShowVerifyPopup] = useState(false)
  const [createdStoreId, setCreatedStoreId] = useState(null)
  const location = useLocation()
  const { userdata } = useAuth()
  const [storeID, SetstoreID] = useState("")
  const params = useParams()
  
    // ✅ Extract store_id from URL (params or pathname)
    const getStoreIdFromUrl = () => {
      if (params?.store_id) return params.store_id
      const pathParts = location.pathname.split('/')
      console.log(pathParts[1])
      return pathParts[1] || null
    }
  
    const store_id = getStoreIdFromUrl()

  const isAccessRestricted =
    isRestricted ||
    !limitedPermission ||
    limitedPermission.custom_dataset_training === false

  const handleBackClick = () => {
    handleback()
  }

  const handleSiteUrlChange = e => {
    setSiteUrl(e.target.value)
    setSitemapUrl(e.target.value)
  }

  const cleanSiteUrl = url => {
    try {
      return new URL(url).hostname
    } catch (error) {
      return url.replace(/(^\w+:|^)\/\//, '')
    }
  }

  const handlepassdata = async () => {
    if (isProcessing) return
    setIsProcessing(true)

    if (!siteUrl || !sitemapUrl) {
      toast.error('Please enter Site URL and Sitemap URL', {
        position: 'bottom-center'
      })
      setIsProcessing(false)
      return
    }

    // let userid = userdata
    let userid = validateJSON(userdata) ? validateJSON(userdata).id : null
    // let userid = Cookies.get('user')
    //   ? validateJSON(Cookies.get('user')).id
    //   : null
    // ✅ Validate website URL
    const urldata = { url: siteUrl }
    const res = await ValidatewebsiteUrl(urldata)

    if (res.status !== 200) {
      setIsProcessing(false)
      return
    }

    // ✅ Validate sitemap URL
    const sitemapRes = await validatesitemapurl({ sitemapUrl: sitemapUrl })
    if (sitemapRes?.status !== 200) {
      // toast.error(sitemapRes?.message || 'Invalid sitemap URL.', {
      //   position: 'bottom-center'
      // })
      setIsProcessing(false)
      return
    }

    toast.success(res.message, {
      position: 'bottom-center'
    })

    // ✅ Store creation
    const data = {
      name: cleanSiteUrl(siteUrl),
      type: 'website',
      user_id: userid,
      status: 'unverified',
      meta: { sitemap: sitemapUrl }
    }

    let storeId = null
    try {
      const store = await CreateStore(data)

      if (store.success) {
        storeId = store.data.store_id
        // localStorage.setItem('store_id', storeId)
        SetstoreID(storeId)
        setCreatedStoreId(storeId)
        localStorage.setItem('storedata', JSON.stringify(store.data))
        if (store.data.status === 'unverified') {
          setShowVerifyPopup(true)
          return
        }

        // Optional: Redirect
        // toast.warn('Redirecting to subscription page...', {
        //   position: 'bottom-center',
        //   autoClose: 4000
        // })
        // setTimeout(() => {
        //   localStorage.removeItem('onboarding')
        //   navigate('/subscription')
        // }, 4000)
      } else {
        toast.error(store.message, {
          position: 'bottom-center'
        })
      }
    } catch (error) {
      console.error('Error during store creation:', error)
      toast.error(error.message, {
        position: 'bottom-center'
      })

      const del = await deleteStorebyID(storeId)
      if (del.success) {
        localStorage.removeItem('store_id')
        localStorage.removeItem('storedata')
      }
    } finally {
      setIsProcessing(false)
    }
  }

  const publishScript = `
  <script  
    src="${process.env.REACT_APP_API_URL}/js/loader.bundle.js" 
    async 
    data-store-id="${storeID}" 
    id="chatbot-script-loader" 
    defer
  ></script>`

  const DeletestoreOnCancel = async () => {
    const deleteresponse = await deleteStorebyID(
      store_id
    )
    if (deleteresponse.success) {
      localStorage.removeItem('store_id')
      localStorage.removeItem('storedata')
      setShowVerifyPopup(false)
    }
  }

  const ValidateScript = async () => {
    let res
    const data = {
      url: siteUrl,
      // storeId: '024b7238ba1350cf5a9d7b8460189078',
      storeId: store_id
    }
    const queryParams = new URLSearchParams(window.location.search)

    const skip_param = queryParams.get('skip_store_validation')
    // console.log(skip_param)
    if (skip_param === 'true') {
      res = {
        success: true
      }
    } else {
      res = await Validatescript(data)
    }

    if (res.success) {
      toast.success('Domain Verified Successfully', {
        position: 'bottom-center'
      })

      const updatedata = {
        status: 'active'
      }
      const updateres = await updateStore(
        store_id,
        updatedata
      )
      if (updateres.success) {
        toast.warn('Redirecting to subscription page...', {
          position: 'bottom-center',
          autoClose: 3000
        })

        setTimeout(() => {
          localStorage.removeItem('onboarding')
          navigate(`/store/${storeID}/subscription`)
          window.dispatchEvent(
            new CustomEvent('storeSwitchedtrigger', { detail: true })
          )
          window.dispatchEvent(
            new CustomEvent('storeChanger', { detail: true })
          )
        }, 4000)
      }
    } else {
      // toast.error(
      //   'Verification Failed – Script Not Found or Invalid Store URL',
      //   {
      //     position: 'bottom-center'
      //   }
      // )
    }
  }

  return (
    <>
      <div className='flex items-start w-full justify-between'>
        <div className='block'>
          <div className='flex items-start mb-1 justify-start'>
            <img src={webicon} alt='' />
            <h1 className='text-[#252530] ml-3 font-extrabold text-[23px] leading-[31px]'>
              Website
            </h1>
          </div>
          <p className='text-[12px] ml-1'>
            Create a Website Chatbot to Enhance Customer Interactions on Any
            Platform.
          </p>
        </div>
        <button
          className='border border-[#7C50DD] rounded-[39px] flex items-center justify-start text-[14px] font-normal p-[10px] h-[44px] bg-white w-[103px]'
          aria-label='Go back'
          onClick={handleBackClick}
        >
          <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M16.1705 4.4545C16.6098 4.89384 16.6098 5.60616 16.1705 6.0455L10.216 12L16.1705 17.9545C16.6098 18.3938 16.6098 19.1062 16.1705 19.5455C15.7312 19.9848 15.0188 19.9848 14.5795 19.5455L7.8295 12.7955C7.39017 12.3562 7.39017 11.6438 7.8295 11.2045L14.5795 4.4545C15.0188 4.01517 15.7312 4.01517 16.1705 4.4545Z'
              fill='#7C50DD'
            />
          </svg>
          <span className='ml-2'>Back</span>
        </button>
      </div>

      <div className='mt-2 relative flex w-full'>
        <form className='w-full flex flex-col gap-5 relative'>
          <div className='flex flex-col gap-3'>
            <label className='text-base '>Website URL</label>
            <input
              type='text'
              className='focus:outline-none website-url-input w-full h-[56px] rounded-[39px] pl-[40px] sm:pr-[100px] pr-[70px] pt-[10px] pb-[10px] placeholder:text-[15px] placeholder:text-[#252530] font-normal'
              placeholder='Enter a URL address'
              value={siteUrl}
              onChange={handleSiteUrlChange}
            />
          </div>
          <div className='flex flex-col gap-3'>
            <label className='text-base'>Sitemap URL</label>
            <input
              type='text'
              className='focus:outline-none sitemap-url-input w-full h-[56px] rounded-[39px] pl-[40px] sm:pr-[100px] pr-[70px] pt-[10px] pb-[10px] placeholder:text-[15px] placeholder:text-[#252530] font-normal'
              placeholder='Enter a Sitemap URL'
              value={sitemapUrl}
              onChange={e => setSitemapUrl(e.target.value)}
            />
            <span className='text-sm text-gray-500 ml-2'>
              Example: <code>https://example.com/sitemap.xml</code>
            </span>
            {sitemapUrl && (
              <span className='text-sm flex gap-2 ml-2 cursor-pointer'>
                <p className='text-black'>Verify Sitemap:</p>
                <a
                  href={sitemapUrl}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='text-[#7C50DD]'
                >
                  {sitemapUrl}
                </a>
              </span>
            )}
          </div>
        </form>
      </div>

      <button
        onClick={handlepassdata}
        type='button'
        className={`mt-3 bg-[#7C50DD] install-button cursor-pointer sm:mt-3 sm:relative flex items-center text-[12px] h-[36px] border-[1px] p-[20px] 
          text-white w-full sm:w-auto justify-center font-medium rounded-[20px]`}
        disabled={isProcessing}
      >
        {isProcessing ? 'Installing...' : 'Install MagBot App'}
      </button>

      <ToastContainer />
      <TooltipWalkthrough pageKey={'/addchatbot'} />

      {showVerifyPopup && (
        <VerifyDomainPopup
          publishScript={publishScript}
          onClose={() => {
            setShowVerifyPopup(false)
            // DeletestoreOnCancel()
          }}
          onVerify={() => {
            // toast.info('Validating ownership using store_id...', {
            //   position: 'bottom-center'
            // })
            ValidateScript()
          }}
          siteurl={siteUrl}
        />
      )}
    </>
  )
}

export default GetWebsiteStore
